import { render, staticRenderFns } from "./DownloadProducts.vue?vue&type=template&id=39a87916&scoped=true&"
import script from "./DownloadProducts.vue?vue&type=script&lang=js&"
export * from "./DownloadProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a87916",
  null
  
)

export default component.exports